/**
 * The party's name as accounting uses it — what AP pays under.
 *
 * `accountingCompanyName` is an HC-entered free-text field and is EMPTY on every
 * one of the 4,531 cbhi parties: nothing has ever populated it, because the
 * NetSuite sync doesn't write it and nobody types it. Yet it is displayed in
 * four places, so it read blank everywhere.
 *
 * `printCheckAs` (NetSuite "print on check as") is the payee name — literally
 * the name the check is made out to — and the sync has carried it all along:
 * populated on 395 of 396 NetSuite-sourced parties, and different from the
 * party's `name` on 199 of them, so it is additive rather than a restatement.
 *
 * Chosen over the two other synced candidates (David's call, 2026-09-17):
 *   - `legalName` duplicates HC's own `name` on 342 of 396 parties, so it would
 *     print the same string twice on the party card, and 187 of its values are
 *     ALL CAPS.
 *   - `companyName` is the better DISPLAY name, but says nothing about payment;
 *     "accounting company name" is an AP question, and print-on-check-as is the
 *     field whose meaning matches the label.
 *
 * Entered value wins so that a human who types one is never overwritten by the
 * nightly sync — the fallback fills the gap, it does not own the field.
 */
export function accountingName(party: any): string {
  const entered = (party?.accountingCompanyName ?? '').toString().trim();
  if (entered) return entered;
  return (party?.printCheckAs ?? '').toString().trim();
}
